module Meevo.Plugins.MeevoMessenger {
    /**
    * Contract to hold string constants used through out the client side application.
    * Using static get() functions so that the members can't be changed by anyone
    */
    export class Constants {

        /**
        * Required parameters for message splitting
        */
        public static get MESSAGE_LENGTH_LIMIT(): number { return 160; }
        public static get MESSAGE_SMS_LENGTH_LIMIT(): number { return 600; }
        public static get SPLIT_MESSAGES_COUNT_LIMIT(): number { return 10; }
        public static get SPLIT_SMS_COUNT_LIMIT(): number { return 1; }
        public static get DELAY_IN_SECONDS_BETWEEN_SPLITTED_MESSAGES(): number { return 1; }

        /**
        * Transfer messages between different users
        */
        public static get MESSAGE_TRANSFER_LIMIT(): number { return 10; }


        public static get DEFAULT_USER_NAME(): string { return '*Unknown'; }
    }
}
